
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    deleteGadgetRequest,
    dashboardPanelSearchRequest
} from 'Redux/actions';

//Styles
import './index.scss'

const DeleteGadget = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const {
        openModal,
        loading,
        result,
        gadget
    } = useSelector(state => state.deleteChartRedux);

    const closeModal = () => {
        dispatch(clearRedux("DASHBOARD_PANEL_DELETE_GADGET"))
    }

    const applyChanges = () => {
        dispatch(deleteGadgetRequest(gadget?.id))
    }

    useEffect(() => {
        if (result?.data) {
            NotificationManager.success(
                messages['dashboard_delete_success_message'],
                messages['dashboard_delete_chart_title'],
                3000,
            );
            dispatch(dashboardPanelSearchRequest())
            closeModal()
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={gadget?.name && `${messages['dashboard_delete_chart_title']} - ${gadget?.name}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div className="delete-chart-modal">
                    <label>{messages['dashboard_delete_chart_description']}</label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteGadget;